<template>
    <div class="coffee-search-wrapper">
        <div>
            <i class="fas fa-search"></i>
        </div>
        <input type="text" class="coffee-search-input" placeholder="Search" v-on:input="valueChanged($event.target.value)" ref="input">
    </div>
</template>

<script>
    import _ from 'lodash'

    export default {
        name: "coffee-filter",
        methods: {
            valueChanged: _.debounce( function (keyword) {
                keyword = this.isEmpty(keyword) ? undefined : keyword;
                this.$emit('paramUpdated', keyword)
            }, 500),
            isEmpty(str) {
                return (str.length === 0 || !str.trim());
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "./../../styles/variables_workplace";

    .coffee-search-wrapper {
        display: flex;
        align-items: center;
        color: white;
        background-color: $black;
        div {
            padding-left: 1.5rem;
        }
    }
    .fa-search {
        font-size: 12px;
        position: relative;
        top: 1px;
    }
    .coffee-search-input {
        height: 3rem;
        padding-left: 10px;
        color: white;
        background-color: $black;
        border: none;
        flex-grow: 1;
    }
    ::placeholder {
        color: white;
        opacity: 1; /* Firefox */
    }
</style>
